<template>
  <div>
    <div class="flex justify-between">
      <p class="header">动态列表</p>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data(){
    return {
      columns: [
        {
          title: '消息类型',
          dataIndex: 'type',
          key: 'type',
          slots: {customRender: 'type'}
        },
        {
          title: '消息内容',
          dataIndex: 'content',
          key: 'content',
          slots: { customRender: 'content' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          slots: {customRender: 'status'}
        },
        {
          title: '发送时间',
          dataIndex: 'createTime',
          key: 'createTime',
          slots: { customRender: 'createTime'}
        }
      ],
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 10,
        showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
      },
    }
  },
  created(){
    let param = {
      pageNum: this.pagination.current,
      pageSize: this.pagination.pageSize
    }
    this.getList(param)
  },
  computed: {
    changeTime(){
      return function(time, type){
        type = type ? type : 'YYYY-MM-DD hh:mm:ss'
        if (type == 'week') {
          let num = moment(time).weekday()
          num = num == 0 ? '周一' : (num==1 ? '周二' : (num==2 ? '周三': (num==3 ? '周四': (num==4 ? '周五' : (num==5 ? '周六' : '周日')))))
          return num
        } else {
          return moment(time).format(type)
        }
      }
    },
  },
  methods: {
    getList(param){
      param.memberId = this.userId
      this.$axios.post('/sys/notice/list', param).then(res=>{
        if (res.code == 200) {
          this.dataSource = res.data.list
          this.pagination.total = res.data.total
        }
      })
    },
    readAll(){
      this.$axios.put('/sys/notice/readAll').then(res=>{
        if (res.code == 200) {
          let param = {
            pageNum: this.pagination.current,
            pageSize: this.pagination.pagesize
          }
          this.getList(param)
        }
      })
    },
    goMsg(item){
      this.readyMsg(item.id)
      if (item.type == 1) {
        // 日程列表
        this.$router.push({
          path: '/schedule/index'
        })
      } else if (item.type == 2) {
        // 动态
        this.$router.push({
          path: '/data',
          query: {
            type: 6,
            // activeType: 5,  // 2-生理生化 3-心理 4-月经 5-病历 6-每日问卷
            id: item.bizId
          }
        })
      }
    },
    readyMsg(id){
      let that = this;
      new Promise((resolve, reject)=>{
        that.$axios.put("/sys/notice/read?id="+id).then((res)=>{
          resolve(res)
        })
      })
    },
    changeTable(page){
      this.pagination.current = page
      let param = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      this.getList(param)
    },
    changeSize(cur, size){
      this.pagination.current = 1
      this.pagination.pageSize = size
      let param = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      this.getList(param)
    }
  }
}
</script>
<style lang="less" scoped>
.header{
  border-left: 4px solid #1890FF;
  padding-left: 16px;
  margin-bottom: 35px;
}
.dot{
  width: 6px;
  height:6px;
  border-radius:50%;
  display:inline-block;
  margin-right: 7px;
}
.pagination_box{
  text-align: right;
}
/deep/.ant-pagination-item-active{
  background-color: #1890FF !important;
}
/deep/.ant-pagination-item {
  background-color: var(--form-bg-color);
  border-color: var(--form-bg-color);
}
/deep/.ant-pagination-item a{
  color: #fff !important;
}
</style>